import {useEffect, useState, useCallback} from 'react';
import Tone from 'tone';
import {NOT_UPLOADED_YET} from 'constants/ipfs-constants.js';
import {decodeFlac} from 'flac/decodeFlac.js';
import Sample from 'repos/Sample.js';
export const useDropFiles = () => {
    let [sounds, setSounds] = useState([]);

    useEffect(() => {
        window.addEventListener("dragenter", dragEnter);
        window.addEventListener("dragover", dragOver);
        window.addEventListener("drop", onDrop);

        return () => {
            window.removeEventListener("dragenter", dragEnter);
            window.removeEventListener("dragover", dragOver);
            window.removeEventListener("drop", onDrop);
        };
    }, [setSounds, sounds]);

    const dragEnter = (e) => {
        e.preventDefault();
        e.dataTransfer.effectAllowed = "none";
        e.dataTransfer.dropEffect = "none";
    };

    const dragOver= (e) => {
        e.preventDefault();
        e.dataTransfer.effectAllowed = "none";
        return false;
    };

    const onDrop = useCallback(async (ev) => {
        ev.preventDefault();
        ev.dataTransfer.effectAllowed = "none";
        ev.dataTransfer.dropEffect = "none";
        
        if (ev.dataTransfer.items) {
            // Use DataTransferItemList interface to access the file(s)
            let _sounds = [... sounds];
            let files = [];
            let len = ev.dataTransfer.items.length;
            for (let i=0; i < ev.dataTransfer.items.length; i++) {
                if (ev.dataTransfer.items[i].kind==='file') {
                    files.push(ev.dataTransfer.items[i].getAsFile());
                }
            }
                
            for (let file of files) { 
                // If dropped items aren't files, reject them
                let sample = await uploadFile(file);
                _sounds = [... _sounds, sample];
            }
            setSounds([... _sounds]);
        } else {
            // Use DataTransfer interface to access the file(s)
            for (var i = 0; i < ev.dataTransfer.files.length; i++) {
            }
        }
        return false;
    }, [setSounds, sounds]);

    const uploadFile = useCallback((file) => {
        return new Promise(resolve => {
        let reader = new FileReader();
        if (!file.name.includes('.wav') && !file.name.includes('.flac')) {
            window.alert('Only accepts .wav files for now');
            return;
        }
        reader.readAsArrayBuffer(file)
        reader.onloadend = async () => {
            let raw = reader.result;
            if (file.name.includes('flac')) {
                raw = await decodeFlac(new Int8Array(raw));
            }
            
            let audioBuffer = await Tone.Master.context.decodeAudioData(raw);
            let sample = new Sample(NOT_UPLOADED_YET);
            sample.audioBuffer = audioBuffer;
            sample.needsSave = true;
            sample.tags = [];
            sample.name = file.name;
            resolve(sample);
        };
        });
    }, [setSounds, sounds]);

    return {sounds};
                                   
};
